import { useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';
import { disableCollectionComments } from '../../../../modules/actions';
import { updateCollectionByPath } from '../../../../modules/actions/collections';
import { CommentsMode } from '../../../../modules/types/comments';
import { useNewCommentsDesign } from '../../../../hooks/useNewCommentsDesign';

interface IParams {
  changeWithUpdate: (path: string, value: string | boolean) => void;
}

/**
 * Enabling comments is immediate. Disabling them asks first what should happen
 * to the comments that already exist (newCommentsDesign only) - the gallery
 * presets deliberately keep the plain instant toggle.
 */
export const useCommentsToggle = ({ changeWithUpdate }: IParams) => {
  const dispatch = useDispatch();
  const isNewCommentsDesign = useNewCommentsDesign();
  const [isDisableModalOpen, setIsDisableModalOpen] = useState(false);

  const handleCommentSwitch = useCallback(
    (value: boolean) => {
      if (isNewCommentsDesign && !value) {
        setIsDisableModalOpen(true);

        return;
      }

      changeWithUpdate('comment', value);

      if (isNewCommentsDesign && value) {
        dispatch(
          updateCollectionByPath({ path: 'commentsMode', value: 'enabled', isSilent: true })
        );
      }
    },
    [isNewCommentsDesign, changeWithUpdate, dispatch]
  );

  const closeDisableModal = useCallback(() => setIsDisableModalOpen(false), []);

  const confirmDisable = useCallback(
    (mode: CommentsMode) => dispatch(disableCollectionComments({ mode })),
    [dispatch]
  );

  return { isDisableModalOpen, handleCommentSwitch, closeDisableModal, confirmDisable };
};
